import { ChevronRight } from 'lucide-react';
import type * as React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className }) => {
  return (
    <nav className={cn('flex items-center text-sm text-muted-foreground', className)} aria-label="Breadcrumb">
      <ol className="flex items-center gap-1.5">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          const Icon = item.icon;

          return (
            <li key={item.href || item.label} className="flex items-center gap-1.5">
              {idx > 0 && <ChevronRight className="h-4 w-4 text-muted-foreground/50" aria-hidden="true" />}
              {isLast ? (
                <span className="font-medium text-foreground flex items-center gap-1.5" aria-current="page">
                  {Icon && <Icon className="h-3.5 w-3.5" />}
                  <span className="max-w-[200px] truncate">{item.label}</span>
                </span>
              ) : (
                <Link
                  to={item.href || '#'}
                  className="hover:text-foreground transition-colors flex items-center gap-1.5"
                >
                  {Icon && <Icon className="h-3.5 w-3.5" />}
                  <span className="max-w-[200px] truncate">{item.label}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
